import { useQuery } from "@tanstack/react-query";
import { api } from "../client";
import { queryKeys } from "../query-keys.ts";

export function useMarketsSelect() {
  return useQuery({
    queryKey: queryKeys.markets.all,
    queryFn: () => api.marketApi.apiMarketsGetCollection().then((r) => r.data),
    meta: {
      skipGlobalError: false,
    },
  });
}
